export default __webpack_public_path__ + "static/card_3-57af33987ef41ef96d8eacf5ac1c964a.png";